import { FILE_EXTENSION_IMAGES } from '@crehana/compass.knowledgehub';

import { DocumentActionEnum } from '@/generated/graphql/types';

import type { TDocumentType } from '../../types';
import type { LearningUserCourseDetailQueryQuery } from './graphql/org-course-detail-collaborator-v2-query.v5.generated';

type TContentBase = NonNullable<
  LearningUserCourseDetailQueryQuery['knowledge_hub_collaborator_v2']['get_collaborator_content_detail']
>;

export const mapCollaboratorV2ToDocument = (
  contentBase: TContentBase,
): TDocumentType | undefined => {
  const { document } = contentBase;

  if (!document || !contentBase.original_id) {
    return undefined;
  }

  const extension = document.extension?.toLocaleLowerCase() || '';
  const coverImage = extension ? FILE_EXTENSION_IMAGES[extension] : '';

  return {
    id: contentBase.original_id,
    name: document.name,
    size: document.size || '',
    description: document.description || '',
    canPreview: document.action === DocumentActionEnum.Preview,
    extension,
    coverImage,
    downloadUrl: document.document_file?.file?.download_url || '',
    categoriesList: contentBase.related_categories.map(category => ({
      id: category.id,
      title: category.title,
    })),
    updatedAt: document.updated_at ? new Date(document.updated_at) : undefined,
  };
};
